const fmt = (iso) => new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "short" });

export default function ProgressChart({ start, startDate, checkins }) {
  const pts = [{ v: start, d: startDate }, ...checkins.map((c) => ({ v: c.punteggio, d: c.data }))];
  const W = 320, H = 140, P = 22;
  const x = (i) => P + (i * (W - 2 * P)) / Math.max(pts.length - 1, 1);
  const vs = pts.map((p) => p.v);
  const lo = Math.max(0, Math.floor((Math.min(...vs) - 10) / 10) * 10), hi = Math.min(100, Math.ceil((Math.max(...vs) + 10) / 10) * 10);
  const y = (v) => H - P - ((v - lo) / (hi - lo || 1)) * (H - 2 * P);
  const line = pts.map((p, i) => `${i ? "L" : "M"}${x(i)},${y(p.v)}`).join(" ");
  const area = `${line} L${x(pts.length - 1)},${H - P} L${x(0)},${H - P} Z`;
  return (
    <div className="mt-4 rounded-3xl border border-[#26262B] bg-[#141417] p-4" data-testid="progress-chart">
      <p className="text-xs uppercase tracking-[0.2em] text-[#9A948A]">I tuoi progressi</p>
      <svg viewBox={`0 0 ${W} ${H}`} className="mt-2 w-full" role="img" aria-label="Grafico del punteggio nel tempo">
        <defs><linearGradient id="pc-fill" x1="0" x2="0" y1="0" y2="1"><stop offset="0" stopColor="#E5B13A" stopOpacity="0.35" /><stop offset="1" stopColor="#E5B13A" stopOpacity="0" /></linearGradient></defs>
        {[lo + (hi - lo) / 4, lo + (hi - lo) / 2, lo + (3 * (hi - lo)) / 4].map((g) => <line key={g} x1={P} x2={W - P} y1={y(g)} y2={y(g)} stroke="#26262B" strokeDasharray="3 4" />)}
        <path d={area} fill="url(#pc-fill)" />
        <path d={line} fill="none" stroke="#E5B13A" strokeWidth="2.5" strokeLinejoin="round" strokeLinecap="round" />
        {pts.map((p, i) => (
          <g key={p.d + i}>
            <circle cx={x(i)} cy={y(p.v)} r="4" fill="#0E0E10" stroke="#F5D27A" strokeWidth="2" />
            <text x={x(i)} y={y(p.v) - 9} textAnchor="middle" fontSize="10" fill="#F4EFE6">{p.v}</text>
          </g>
        ))}
      </svg>
      <div className="flex justify-between text-xs text-[#9A948A]"><span>Partenza · {fmt(startDate)}</span><span>Ultimo check · {fmt(pts[pts.length - 1].d)}</span></div>
    </div>
  );
}
